function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLocation } from "@custom/schema";
import React, { useEffect, useState } from "react";
import AnimatedCursor from "react-animated-cursor";
export default function Pointer() {
    var _useState = _sliced_to_array(useState(false), 2), inBrowser = _useState[0], setInBrowser = _useState[1];
    var _useLocation = _sliced_to_array(useLocation(), 1), location = _useLocation[0];
    useEffect(function() {
        setInBrowser(true);
    }, []);
    useEffect(function() {
        var outerCursor = document.querySelector('[style*="mix-blend-mode"]');
        var innerCursor = document.querySelector('[style*="background-color: rgb(0, 0, 0)"]');
        if (_instanceof(outerCursor, HTMLElement)) outerCursor.style.opacity = "0";
        if (_instanceof(innerCursor, HTMLElement)) innerCursor.style.opacity = "0";
        var timeout = setTimeout(function() {
            if (_instanceof(outerCursor, HTMLElement)) outerCursor.style.opacity = "1";
            if (_instanceof(innerCursor, HTMLElement)) innerCursor.style.opacity = "1";
        }, 20);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        location.pathname
    ]);
    if (!inBrowser) return null;
    return /*#__PURE__*/ React.createElement(AnimatedCursor, {
        color: "241,242,243",
        innerSize: 11,
        outerSize: 12,
        innerScale: 0,
        outerScale: 3.4,
        outerAlpha: 0.9,
        trailingSpeed: 1,
        innerStyle: {
            transition: "opacity 0.3s ease-in-out, height 0.07s ease-in-out, width 0.07s ease-in-out",
            zIndex: 999999,
            backgroundColor: "rgb(0,0,0)"
        },
        outerStyle: {
            mixBlendMode: "difference",
            backgroundColor: "rgba(55,52,48,0.7)",
            zIndex: 999999,
            border: "0"
        },
        clickables: [
            "a",
            'input[type="text"]',
            'input[type="email"]',
            'input[type="number"]',
            'input[type="submit"]',
            'input[type="image"]',
            "label[for]",
            "select",
            "textarea",
            "button",
            ".link",
            ".swiper-button-next",
            ".swiper-button-prev"
        ]
    });
}
